var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileReelSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none",
  viewBox: "0 0 21 21",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.473 16.888A9.46 9.46 0 0 1 9.5 19 9.5 9.5 0 1 1 19 9.5a9.46 9.46 0 0 1-2.113 5.973l3.82 3.82a1 1 0 0 1-1.414 1.414zM17 9.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0",
  clipRule: "evenodd"
})));
export default SvgFacebookMobileReelSearch;